import { useEffect, useState } from 'react';
import type { RefObject } from 'react';

export function useElementSize<TElement extends Element>(ref: RefObject<TElement>) {
  const [size, setSize] = useState({ height: 1, width: 1 });

  useEffect(() => {
    const element = ref.current;

    if (!element) {
      return;
    }

    const updateSize = () => {
      const rect = element.getBoundingClientRect();
      setSize({ height: Math.max(1, rect.height), width: Math.max(1, rect.width) });
    };

    updateSize();

    const resizeObserver = new ResizeObserver(updateSize);
    resizeObserver.observe(element);

    return () => {
      resizeObserver.disconnect();
    };
  }, [ref]);

  return size;
}
